import { findParentNodeByCls } from "./util.js";

const D_VERTICAL = "v"; // 方向 v 垂直方向，h水平方向

/**
 * 可移动组件，移动开始入口
 * 《important重要》 会给移动的元素加 moving 样式名
 * @param event dom事件，mousedown事件
 * @param dragableCls 可移动元素的className
 * @param direct 方向 v 垂直方向，h水平方向
 * @param dropCB 松手的时候的回调
 */
export function dragStart(event, dragableCls, direct, dropCB) {
    const curDragableElem = findParentNodeByCls(event.target, dragableCls); // 当前选中的可移动组件

    if (!curDragableElem) {
        return;
    }

    const dragPanel = curDragableElem.parentNode; // 所有可移动组件的父节点
    const panelModifyFlag = fixedDomSize(dragPanel); // 防止全局影响，导致全局回流重绘

    // 设置选择元素为不可见，添加clone元素
    const cloneElem = cloneVisibleDeep(curDragableElem);
    setVisible(curDragableElem, "hidden");
    dragPanel.appendChild(cloneElem);
    tran2Moving(curDragableElem, cloneElem, dragPanel);

    // 注册事件
    const mouseMove = throttle(mouseMoveHandler, 50, 200);

    window.document.addEventListener("mousemove", mouseMove);
    window.document.addEventListener("mouseup", mouseUp);

    // 初始化状态
    let moveState = {
        startTop: parseInt(cloneElem.style.top),
        startLeft: parseInt(cloneElem.style.left),
        width: parseInt(cloneElem.style.width),
        height: parseInt(cloneElem.style.height),
        direct: direct,
        startX: event.pageX,
        startY: event.pageY,
        curOverIdx: -1, // 当前经过的元素
        curPosition: -1, // 当前经过的位置，上t下b，左l右r
        curDragIdx: -1, // 当前元素应该放置的位置
        orgPostion: getElemIdx(dragPanel, curDragableElem)
    };

    function mouseMoveHandler(event) {
        const curX = event.pageX;
        const curY = event.pageY;

        addPosition(cloneElem, curX, curY, moveState);

        // 计算剩余元素位置
        resetPosition(dragPanel, cloneElem, curDragableElem, moveState);
    }

    function mouseUp() {
        // 恢复改动
        setOverElemMargin(dragPanel, moveState, true);
        releaseDomSize(dragPanel, panelModifyFlag);
        dragPanel.removeChild(cloneElem);
        setDisplay(curDragableElem);
        setVisible(curDragableElem);

        const newIdx = moveState.curDragIdx > moveState.orgPostion ? moveState.curDragIdx - 1 : moveState.curDragIdx;
        const hasChanged = newIdx !== moveState.orgPostion && newIdx != -1;
        hasChanged && dropCB && dropCB(newIdx);

        window.document.removeEventListener("mousemove", mouseMove);
        window.document.removeEventListener("mouseup", mouseUp);
    }
}

// 宽高固定当前大小 return 0未修改 1修改了width 2修改了height 3全修改了
function fixedDomSize(elem, distElem = elem) {
    const styles = window.getComputedStyle(elem);

    const width = styles.getPropertyValue("width");
    const height = styles.getPropertyValue("height");

    let ret = 0;
    if (elem.style.width && elem.style.height) {
        return ret;
    }

    elem.style.width || ((distElem.style.width = width), (ret += 1));
    elem.style.height || ((distElem.style.height = height), (ret += 2));
    elem.style.userSelect = "none";

    return ret;
}

// fixedDomSize返函数 return 0未修改 1修改了width 2修改了height 3全修改了
function releaseDomSize(elem, flag) {
    (flag === 2 || flag === 3) && (elem.style.width = "");
    (flag === 2 || flag === 3) && (elem.style.height = "");
    elem.style.userSelect = "";
}

// 深度复制可见元素
function cloneVisibleDeep(elem) {
    let cloneElem = elem.cloneNode();

    let childElement = elem.firstElementChild;

    // fix文本节点不属于Element问题
    let firstElem = elem.firstChild;
    if (firstElem && firstElem.nodeType == 3) {
        cloneElem.innerText = elem.innerText;
    }

    while (childElement !== null) {
        const styles = window.getComputedStyle(childElement);
        if (styles.getPropertyValue("display") != "none") {
            cloneElem.appendChild(cloneVisibleDeep(childElement));
        }

        childElement = childElement.nextElementSibling;
    }

    cloneElem.style.zIndex = "9999";

    return cloneElem;
}

// 设置元素可见状态
function setVisible(elem, visible) {
    elem.style.visibility = visible || "";
}

// 设置元素可见状态
function setDisplay(elem, ds) {
    elem.style.display = ds || "";
}

// 设置元素为absolute, 保持位置不变
function tran2Moving(curElem, cloneElem, parent) {
    const parentRect = parent.getBoundingClientRect();
    const curRect = curElem.getBoundingClientRect();
    const top = curRect.top - parentRect.top;
    const left = curRect.left - parentRect.left;

    cloneElem.style.position = "absolute";
    cloneElem.style.top = top + "px";
    cloneElem.style.left = left + "px";
    cloneElem.setAttribute("class", cloneElem.getAttribute("class") + " moving");
    fixedDomSize(curElem, cloneElem);
}

// 设置位置
function addPosition(elem, x, y, moveState) {
    elem.style.top = moveState.startTop + y - moveState.startY + "px";
    elem.style.left = moveState.startLeft + x - moveState.startX + "px";
}

// 重新设置位置
function resetPosition(dragPanel, cloneElem, curDragableElem, moveState) {
    setDisplay(curDragableElem, "none");

    const maxElem = getMaxInterSectElem(dragPanel, cloneElem, curDragableElem);

    if (!maxElem) {
        // 清除状态为初始，还原已修改元素margin
        setOverElemMargin(dragPanel, moveState, true);
        clearMoveState(moveState);
        return;
    }

    let newPosition = moveState.direct == D_VERTICAL ? (maxElem.section.atTop ? "t" : "b") : maxElem.section.atLeft ? "l" : "r";
    if (moveState.curOverIdx == maxElem.idx && newPosition == moveState.curPosition) {
        return;
    }

    setOverElemMargin(dragPanel, moveState, true);
    resetMoveState(moveState, maxElem, newPosition);
    setOverElemMargin(dragPanel, moveState, false);
}

// 获取相交面积最大的元素
function getMaxInterSectElem(dragPanel, cloneElem, curDragableElem) {
    let maxSection = null;
    let maxIdx = -1;

    let elemItem = dragPanel.firstElementChild;
    let idx = 0;

    while (elemItem != null) {
        let section = getIntersection(cloneElem, elemItem);
        if (elemItem != curDragableElem && section != null) {
            if (!maxSection || maxSection.area < section.area) {
                maxSection = section;
                maxIdx = idx;
            }
        }

        elemItem = elemItem.nextElementSibling;
        idx++;
    }

    if (maxIdx === -1) {
        return null;
    }

    return {
        idx: maxIdx,
        section: maxSection
    };
}

// 计算两个元素交叉的面积和A相对B位置
function getIntersection(elemA, elemB) {
    if (elemA == elemB) {
        return null;
    }

    const rectA = getMarginBoundingRect(elemA);
    const rectB = getMarginBoundingRect(elemB);

    const vLen = calcRectLength(rectA, rectB, "height", "top"); //parseInt(rectA.height - Math.abs(rectA.top + rectA.height - rectB.top - rectB.height));
    const hLen = calcRectLength(rectA, rectB, "width", "left"); //parseInt(rectA.width - Math.abs(rectA.left + rectA.width - rectB.left - rectB.width));

    // 不相交
    if (vLen <= 0 || hLen <= 0) {
        return null;
    }

    return {
        area: vLen * hLen,
        atTop: isAtStartRect(rectA, rectB, "height", "top"),
        atLeft: isAtStartRect(rectA, rectB, "width", "left")
    };
}

// 计算包含margin在内的BoundingRect
function getMarginBoundingRect(elem) {
    const clientRect = elem.getBoundingClientRect();
    const style = window.getComputedStyle(elem);

    return {
        top: clientRect.top - parseInt(style.marginTop),
        height: clientRect.height + parseInt(style.marginTop) + parseInt(style.marginBottom),
        bottom: clientRect.bottom + parseInt(style.marginBottom),
        left: clientRect.left - parseInt(style.marginLeft),
        width: clientRect.width + parseInt(style.marginLeft) + parseInt(style.marginRight),
        right: clientRect.right + parseInt(style.marginRight)
    };
}

// 计算相交的长度
function calcRectLength(rectA, rectB, lenName, startName) {
    let maxRect = rectA[lenName] > rectB[lenName] ? rectA : rectB;
    let minRect = rectA === maxRect ? rectB : rectA;

    let len = -1;
    let dist = -1;
    if (minRect[startName] + minRect[lenName] < maxRect[startName]) {
        dist = maxRect[startName] - minRect[startName] - minRect[lenName];
    } else if (minRect[startName] > maxRect[startName] + maxRect[lenName]) {
        dist = minRect[startName] - maxRect[startName] - maxRect[lenName];
    }
    // 相交分为 上，包含，下三种相交情况
    else {
        if (minRect[startName] < maxRect[startName]) {
            len = minRect[startName] + minRect[lenName] - maxRect[startName];
        } else if (minRect[startName] + minRect[lenName] < maxRect[startName] + maxRect[lenName]) {
            len = minRect[lenName];
        } else {
            len = maxRect[startName] + maxRect[lenName] - minRect[startName];
        }
    }

    // 正好相邻的情况，防止抖动
    if (parseInt(dist) === 1) {
        len = 1;
    }

    return len;
}

// 判断相交是在上部还是下部，A相对于B
function isAtStartRect(rectA, rectB, lenName, startName) {
    return rectA[startName] + rectA[lenName] / 2 < rectB[startName] + rectB[lenName] / 2;
}

// 恢复元素的margin
function setOverElemMargin(dragPanel, moveState, isRecover) {
    let elemItem = dragPanel.firstElementChild;
    let idx = 0;

    while (elemItem != null && idx <= moveState.curOverIdx) {
        if (idx == moveState.curOverIdx) {
            let ratio = isRecover ? -1 : 1;
            setMargin(elemItem, moveState.curPosition, moveState.direct == D_VERTICAL ? ratio * moveState.height : ratio * moveState.width);
        }

        elemItem = elemItem.nextElementSibling;
        idx++;
    }
}

// 清除已设置状态
function clearMoveState(moveState) {
    moveState.curOverIdx = -1;
    moveState.curPosition = -1;
    moveState.curDragIdx = -1;
}

// 设置margin
function setMargin(elem, direct, value) {
    const ds = {
        t: "marginTop",
        b: "marginBottom",
        r: "marginRight",
        l: "marginLeft"
    };

    let mProp = ds[direct];
    if (mProp) {
        let newMargin = elem.style[mProp] ? parseInt(elem.style[mProp]) + value : value;
        elem.style[mProp] = newMargin ? newMargin + "px" : "";
    }
}

// 重新设置状态
function resetMoveState(moveState, maxElem, newPosition) {
    moveState.curOverIdx = maxElem.idx;
    moveState.curPosition = newPosition;
    moveState.curDragIdx = newPosition == "l" || newPosition == "t" ? maxElem.idx : maxElem.idx + 1;
}

// 获取当前element在父节点的idx
function getElemIdx(dragPanel, curDragableElem) {
    let elemItem = dragPanel.firstElementChild;
    let idx = 0;

    while (elemItem != null) {
        if (elemItem == curDragableElem) {
            return idx;
        }

        elemItem = elemItem.nextElementSibling;
        idx++;
    }

    return null;
}

// 节流函数
export function throttle(method, duration) {
    let begin = new Date();

    return function() {
        let context = this,
            args = arguments;
        let current = new Date();
        if (current - begin >= duration) {
            method.apply(context, args);
            begin = current;
        }
    };
}
